import { api } from "../lib/axios";

import type { VectorEmbeddingModel } from "../types/vector";
import type { ApiData } from "./apiData";

interface UpdateVectorMetadatasValueBody {
    embeddingModelName: VectorEmbeddingModel
    filesIds: Array<string>
    metadatas: Array<{
        name: string
        newValue: string
    }>
}

interface UpdateVectorMetadatasValueData {
    message: string
}

async function updateVectorMetadatasValue(body: UpdateVectorMetadatasValueBody) {
    const response = await api.put<ApiData<UpdateVectorMetadatasValueData>>(
        '/vector/metadata/change-value',
        body
    )

    return response.data
}

export {
    updateVectorMetadatasValue,
    type UpdateVectorMetadatasValueBody,
    type UpdateVectorMetadatasValueData
}